const ESP_HTTP_URL = "http://localhost:6210/crypto"
const REQUEST_TIMEOUT_MS = 2 * 60 * 1000

const ERROR_MESSAGE = {
  AGENT_UNAVAILABLE: "Не установлены необходимые программы для ключа ESP",
  KEY_NOT_FOUND: "ESP ключ не найден",
  TIMEOUT: "ESP javob bermadi (vaqt tugadi)",
  OPERATION_FAILED: "ESP operatsiya muvaffaqiyatsiz",
  CERT_NOT_FOUND: "Certificate topilmadi",
  EMPTY_SIGNATURE: "ESP imzo qaytarmadi",
  NO_DATA: "Sign qilish uchun ma'lumot yo‘q",
}

function createError(message) {
  return {
    response: {
      data: {
        status: 400,
        errors: [message],
      },
    },
  }
}

function createResponseError(response) {
  const { comments, message, errorCode } = response ?? {}
  const text = comments || message || ERROR_MESSAGE.OPERATION_FAILED

  return createError(errorCode ? `${text} (ESP xato kodi: ${errorCode})` : text)
}

// Uses fetch instead of axios so global interceptors (Authorization, X-Attestation)
// never leak to the local agent. Content-Type is intentionally omitted to keep it
// a "simple request" and avoid a CORS preflight (OPTIONS).
async function request(method, payload) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS)

  const createRequestError = message =>
    createError(controller.signal.aborted ? ERROR_MESSAGE.TIMEOUT : message)

  try {
    const res = await fetch(`${ESP_HTTP_URL}/${method}`, {
      method: "POST",
      body: payload ? JSON.stringify(payload) : undefined,
      signal: controller.signal,
    }).catch(() => {
      throw createRequestError(ERROR_MESSAGE.AGENT_UNAVAILABLE)
    })

    const response = await res.json().catch(() => {
      throw createRequestError(
        res.ok
          ? ERROR_MESSAGE.KEY_NOT_FOUND
          : `ESP xizmati xatosi (HTTP ${res.status})`,
      )
    })

    if (!res.ok || response?.status !== "success") {
      throw createResponseError(response)
    }

    return response
  } finally {
    clearTimeout(timer)
  }
}

async function getCert() {
  const { certInfos } = await request("getCertInfo")
  const cert = certInfos?.[0]

  if (!cert?.thumbprint)
    throw createError(ERROR_MESSAGE.CERT_NOT_FOUND)

  return cert
}

async function signMsg(data, cert) {
  const response = await request("signMSG", {
    obj: String(data),
    cms: false,
    detached: false,
    cert_thumb: String(cert.thumbprint),
    cert_sn: cert.serialnumber || "",
    pin: "",
    codepage: 1251,
  })

  if (!response.signedMsg)
    throw createError(ERROR_MESSAGE.EMPTY_SIGNATURE)

  return response
}

function signSequentially(dataArray, cert) {
  return dataArray.reduce(async (previous, data) => {
    const signedMessages = await previous
    const { signedMsg } = await signMsg(data, cert)

    return [...signedMessages, signedMsg]
  }, Promise.resolve([]))
}

const ESPHttpService = {
  async signedData(data) {
    const cert = await getCert()

    return { data: await signMsg(data, cert), cert }
  },

  async signedDataMultiple(dataArray) {
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
      throw createError(ERROR_MESSAGE.NO_DATA)
    }

    const cert = await getCert()

    return { data: await signSequentially(dataArray, cert) }
  },
}

export default ESPHttpService
